import {EntitiesProperties} from "../../../utils/enums";

export const metricsComparisonKeyMap = {
    "0":"selectedDates",
    "1":"dayAgo",
    "7":"weekAgo",
    "28":"monthAgo",
    "30":"fullMonthAgo",
    "-1": "specificComparisonDate"
}

export const getMetricFromTotals = (metric:string,totals:any) => {
    const {PROFIT, PROFIT_PERCENT, FILL_RATE, COST, IMPRESSIONS, REQUESTS, REVENUE, CPM, RPM, VCR, NET_PROFIT, NET_COST, NET_REVENUE, COMPLETION} = EntitiesProperties.NUMERIC.ALL

    const profitValue = totals[REVENUE] - totals[COST]
    const netProfit = totals[NET_REVENUE] - totals[NET_COST]
    const profitPercentValue = (profitValue / totals.revenue) * 100
    const fillRateValue = ((totals?.impressions || 0) / (totals?.requests)) * 100
    const cpm = totals?.impressions === 0 ? 0 : totals?.cost / totals?.impressions * 1000
    const rpm = totals?.impressions === 0 ? 0 : totals?.revenue / totals?.impressions * 1000
    const vcr = totals?.impressions === 0 ? 0 : totals?.completion / totals.impressions * 100
    switch (metric) {
        case COST:
        case IMPRESSIONS:
        case REVENUE:
        case REQUESTS:
        case NET_COST:
        case NET_REVENUE:
            return totals[metric]
        case CPM:
            return cpm
        case RPM:
            return rpm
        case PROFIT:
            return profitValue

        case PROFIT_PERCENT:
            return profitPercentValue

        case FILL_RATE:
            return fillRateValue
        case NET_PROFIT:
            return netProfit
        case COMPLETION:
            return totals[COMPLETION]
        case VCR:
            return vcr
        default:
            return ""
    }
}


